import BookingForm from "@/components/BookingForm";
import { ChevronDown, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";

export default function Hero() {
  const { t } = useLang();
  return (
    <section className="relative min-h-screen w-full overflow-hidden pt-20">
      <div className="absolute inset-0">
        <img
          src="https://images.pexels.com/photos/17148730/pexels-photo-17148730.jpeg"
          alt="Luxury car on bridge at twilight"
          className="absolute inset-0 w-full h-full object-cover animate-ken-burns motion-reduce:animate-none [will-change:transform] origin-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#050505] via-[#050505]/85 to-[#050505]/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-[#050505]/30" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 py-16 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-6 animate-fade-up">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#C5A059]/30 bg-[#C5A059]/5 mb-8">
              <span className="w-1.5 h-1.5 rounded-full bg-[#C5A059] animate-pulse" />
              <span className="text-xs uppercase tracking-[0.2em] text-[#C5A059]">{t("hero.badge")}</span>
            </div>

            <h1
              data-testid="hero-headline"
              className="font-display text-5xl sm:text-6xl lg:text-7xl text-white font-light tracking-tight leading-[1.05]"
            >
              {t("hero.title_a")} <br />
              <span className="italic gold-text">{t("hero.title_b")}</span><br />
              {t("hero.title_c")}
            </h1>

            <p className="mt-8 text-lg text-zinc-300 max-w-xl leading-relaxed">{t("hero.sub")}</p>

            <div className="mt-10 flex flex-wrap gap-4 items-center">
              <a
                href="#book"
                data-testid="hero-cta-book"
                className="px-7 py-4 rounded-full bg-[#C5A059] hover:bg-[#D4AF37] text-black font-medium transition-all duration-300 hover:shadow-[0_0_36px_rgba(197,160,89,0.4)]"
              >
                {t("hero.cta_book")}
              </a>
              <a
                href="#fleet"
                data-testid="hero-cta-fleet"
                className="px-7 py-4 rounded-full border border-white/15 text-white hover:border-[#C5A059] hover:text-[#C5A059] transition-all duration-300"
              >
                {t("hero.cta_fleet")}
              </a>
            </div>

            <Link
              to="/postani-vozac"
              data-testid="hero-driver-ribbon"
              className="group mt-6 inline-flex items-center gap-3 text-[11px] uppercase tracking-[0.28em] text-zinc-500 hover:text-[#C5A059] transition-colors"
            >
              <span className="hidden sm:inline">{t("hero.driver_ribbon_prefix")}</span>
              <span className="inline-flex items-center gap-1.5 text-[#C5A059] group-hover:text-[#D4AF37]">
                {t("hero.driver_ribbon_cta")}
                <ArrowUpRight className="w-3.5 h-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </span>
            </Link>

            <div className="mt-14 flex flex-wrap gap-8 items-center text-xs uppercase tracking-[0.2em] text-zinc-500">
              <div className="flex items-center gap-3">
                <span className="text-[#C5A059] text-lg">★</span>
                <span>{t("hero.stat_rating")}</span>
              </div>
              <div>{t("hero.stat_trips")}</div>
              <div>{t("hero.stat_since")}</div>
            </div>
          </div>

          <div id="book" className="lg:col-span-6 animate-fade-up" style={{ animationDelay: "150ms" }}>
            <BookingForm />
          </div>
        </div>

        <a
          href="#services"
          className="hidden lg:flex absolute bottom-8 left-1/2 -translate-x-1/2 flex-col items-center gap-2 text-zinc-500 hover:text-[#C5A059] transition-colors"
        >
          <span className="text-[10px] uppercase tracking-[0.3em]">{t("hero.scroll")}</span>
          <ChevronDown className="w-4 h-4 animate-bounce" />
        </a>
      </div>
    </section>
  );
}
